export const localeLoaders = {
  en: () => import("./locales/en.json").then((m) => m.default || m),
  es: () => import("./locales/es.json").then((m) => m.default || m),
  ru: () => import("./locales/ru.json").then((m) => m.default || m),
  de: () => import("./locales/de.json").then((m) => m.default || m),
  fr: () => import("./locales/fr.json").then((m) => m.default || m),
  it: () => import("./locales/it.json").then((m) => m.default || m),
  pl: () => import("./locales/pl.json").then((m) => m.default || m),
  cs: () => import("./locales/cs.json").then((m) => m.default || m),
  sk: () => import("./locales/sk.json").then((m) => m.default || m),
  hu: () => import("./locales/hu.json").then((m) => m.default || m),
  bg: () => import("./locales/bg.json").then((m) => m.default || m),
  hr: () => import("./locales/hr.json").then((m) => m.default || m),
  sl: () => import("./locales/sl.json").then((m) => m.default || m),
  sr: () => import("./locales/sr.json").then((m) => m.default || m),
  ro: () => import("./locales/ro.json").then((m) => m.default || m),
  lt: () => import("./locales/lt.json").then((m) => m.default || m),
  lv: () => import("./locales/lv.json").then((m) => m.default || m),
  et: () => import("./locales/et.json").then((m) => m.default || m),
  fi: () => import("./locales/fi.json").then((m) => m.default || m),
  sv: () => import("./locales/sv.json").then((m) => m.default || m),
  da: () => import("./locales/da.json").then((m) => m.default || m),
  no: () => import("./locales/no.json").then((m) => m.default || m),
  nl: () => import("./locales/nl.json").then((m) => m.default || m),
  pt: () => import("./locales/pt.json").then((m) => m.default || m),
  el: () => import("./locales/el.json").then((m) => m.default || m),
  ar: () => import("./locales/ar.json").then((m) => m.default || m),
  ka: () => import("./locales/ka.json").then((m) => m.default || m),
  az: () => import("./locales/az.json").then((m) => m.default || m),
  uk: () => import("./locales/uk.json").then((m) => m.default || m),
  uz: () => import("./locales/uz.json").then((m) => m.default || m)
};
export async function loadLocaleData(code) {
  if (!isLocaleAvailable(code)) {
    throw new Error(`Locale ${code} is not available`);
  }
  const loader = localeLoaders[code];
  return await loader();
}
export function isLocaleAvailable(code) {
  return code in localeLoaders;
}
export function getAvailableLocaleCodes() {
  return Object.keys(localeLoaders);
}
export function getLocaleCount() {
  return getAvailableLocaleCodes().length;
}
export function isValidLocaleCode(code) {
  return /^[a-z]{2}$/.test(code) && isLocaleAvailable(code);
}
